let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3T2eQ")).then(() => parcelRequire('3WUNe'));